import {
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { IDmsConfig } from '../../interface/document.manager.interface';
import { State } from '../document-list/document-list.component';
import { DriveFile } from '../../models/DriveFile';
import { DocumentManagerService } from '../../services/document-manager.service';
import { ExtMap } from './extension-map';
import {  UserInfoService } from '@ecap3/core';
import { DocumentShareDialogComponent } from '../..';
import { openInMobileBrowser } from 'src/app/shared/helpers/googleMapApi.helpers';

@Component({
    selector: 'app-document-file-item',
    templateUrl: './document-file-item.component.html',
    styleUrls: ['./document-file-item.component.scss']
})
export class DocumentFileItemComponent implements OnInit {
    @Input() File: DriveFile;
    @Input() Selected: boolean;
    @Input() ExtMapConfig: any;
    @Input() dmsConfig: IDmsConfig;
    @Input() UserId: string;
    @Input() State: State;
    fileType: string;
    userInfo: any = {};
    constructor(
        public userInfoService: UserInfoService,
        private documentManagerService: DocumentManagerService,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private translateService: TranslateService,
    ) {}
    shareDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    renameDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    downloadDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    deleteDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    actionFeature: any[] = [];
    isPayrollDoc = false;
    ngOnInit() {
        console.log(this.File);
        this.isPayrollDoc =
            this.File.Description &&
            this.File.Description.indexOf('payroll_') == 0;
        this.AddImageFromFileExtension(this.File);
        if (this.dmsConfig.moduleFeatureId) {
            this.shareDocFeature = this.dmsConfig.features.shareDoc;
            this.renameDocFeature = this.dmsConfig.features.addDoc;
            this.deleteDocFeature = this.dmsConfig.features.deleteDoc;
            this.downloadDocFeature = [
                ...this.dmsConfig.features.addDoc,
                ...this.dmsConfig.features.deleteDoc,
                ...this.dmsConfig.features.shareDoc
            ];
        }
        if (this.dmsConfig.features.addDoc)
            this.actionFeature.push(...this.dmsConfig.features.addDoc);
        if (this.dmsConfig.features.deleteDoc)
            this.actionFeature.push(...this.dmsConfig.features.deleteDoc);
        if (this.dmsConfig.features.shareDoc)
            this.actionFeature.push(...this.dmsConfig.features.shareDoc);
        if (this.downloadDocFeature)
            this.actionFeature.push(...this.downloadDocFeature);
    }

    AddImageFromFileExtension(_File: DriveFile) {
        let ext = _File.Name.split('.').pop();
        this.getFileType(ext);
        if (ext) {
            if (ext.length > 0) {
                ext = ext.toLowerCase();
                if (this.ExtMapConfig) {
                    if (ext in this.ExtMapConfig) {
                        this.File.IconName = this.ExtMapConfig[ext].IconName;
                    } else {
                        this.File.IconName = this.ExtMapConfig.default.IconName;
                    }
                } else if (ext in ExtMap) {
                    this.File.IconName = ExtMap[ext].IconName;
                } else {
                    this.File.IconName = ExtMap.default.IconName;
                }
            }
        }
    }
    getFileType(ext: string) {
        const imageFileTypes = [
            'jpg',
            'png',
            'jpeg',
            'bmp',
            'tif',
            'tiff',
            'gif',
            'raw',
            'ico',
            'ps',
            'psd',
            'svg',
            'JPG',
            'PNG',
            'JPEG',
            'BMP',
            'TIF',
            'TIFF',
            'GIF',
            'RAW',
            'ICO',
            'PS',
            'PSD',
            'SVG'
        ];
        const videoFileTypes = [
            'mp4',
            'mkv',
            'avi',
            '3gp',
            'mpeg4',
            'mov',
            'wmv',
            'webm',
            'flv'
        ];
        const audioFileTypes = [
            'mp3',
            'wav',
            'aac',
            '3gp',
            'm4a',
            'wma',
            'flac',
            'alac'
        ];
        // const officeDocFileTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];
        if (ext === 'pdf') {
            this.fileType = 'pdf';
        } else if (imageFileTypes.includes(ext)) {
            this.fileType = 'image';
        } else if (videoFileTypes.includes(ext)) {
            this.fileType = 'video';
        } else if (audioFileTypes.includes(ext)) {
            this.fileType = 'audio';
        } else {
            this.fileType = 'unsupported';
        }
    }

    downloadLink(file) {
        console.log('File: ', file);
        openInMobileBrowser(file.Url);
    }

    download(item, event) {
        event.stopPropagation()
        console.log('File: ', item);
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService.downloadFile(item.FileStorageId).then(
            (response) => {
                this.documentManagerService.changeworkingState('idle');
                if (!response.Status) {
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                        )
                    );
                }
            },
            (error) => {
                console.log(error);
                this.documentManagerService.changeworkingState('idle');
                this.matSnackBarOpen(
                    this.translateService.instant(
                        'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_DOWNLOADING_FILE'
                    )
                );
            }
        );
    }


    share(File) {
        this.documentManagerService.documentShareEvent.emit({
            file: File,
            type: 'File'
        });
        const dialogRef = this.dialog.open(DocumentShareDialogComponent, {
            width: '600px',
            data: {
                File: File,
                Type: 'File',
                dmsConfig: this.dmsConfig
            },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((resp) => {
            if (!resp.canceled) {
                if (resp.success) {
                    this.documentManagerService.changeworkingState('idle');
                    this.snackBar.open(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_FILE_SHARED'
                        ),
                        null,
                        {
                            duration: 3000
                        }
                    );
                } else {
                    this.documentManagerService.changeworkingState('idle');
                    this.snackBar.open(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                        ),
                        null,
                        {
                            duration: 3000
                        }
                    );
                }
            }
        });
    }

    matSnackBarOpen(value, duration?: number) {
        const translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
}
